import { TMasterSpecificSkillCertificate } from "@/api/entities/master-specific-skill-certificate.entity";

/**
 * A 特定技能合格証 is selectable for a talent only when the certificate has an
 * explicit, non-hidden mapping to that talent's 分野.
 *
 * Both sides are coerced because the junction FKs arrive as strings while the
 * certificate id is a number.
 */
export const isCertificateValidForIndustry = (
  certificate: TMasterSpecificSkillCertificate,
  industryId: number | string | null | undefined,
): boolean => {
  if (industryId === null || industryId === undefined || industryId === "") return false;

  return (
    certificate.specificSkillCertificateCompanySpecificIndustries?.some(
      (mapping) => Number(mapping.companySpecificIndustryId) === Number(industryId) && !mapping.isHidden,
    ) ?? false
  );
};

/**
 * Submit-side rule: only certificates explicitly hidden for the talent's 分野 are
 * dropped. A certificate with no mapping row is kept, because real records hold
 * such values and the user entered them deliberately — this mirrors the server's
 * write-path guard. The stricter predicate above stays for dropdown options.
 */
export const isCertificateHiddenForIndustry = (
  certificate: TMasterSpecificSkillCertificate,
  industryId: number | string | null | undefined,
): boolean => {
  if (industryId === null || industryId === undefined || industryId === "") return false;

  return (
    certificate.specificSkillCertificateCompanySpecificIndustries?.some(
      (mapping) => Number(mapping.companySpecificIndustryId) === Number(industryId) && mapping.isHidden,
    ) ?? false
  );
};
